import { DOCUMENT } from '@angular/common';
import { Component, Inject, OnInit, ViewChild } from '@angular/core';
// import { AngularFireAnalytics } from '@angular/fire/analytics';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbAlert, NgbCarousel, NgbCollapse, NgbCollapseConfig, NgbModal, NgbModalConfig, NgbModalRef } from 'node_modules/@ng-bootstrap/ng-bootstrap';
import CONFIG from 'src/app/app.config';
import { Decision } from 'src/app/d3/models/decision';
import { Feedback } from 'src/app/d3/models/feedback';
import { Motivator } from 'src/app/d3/models/motivator';
import { Summary } from 'src/app/d3/models/summary';
import { User } from 'src/app/d3/models/user';
import { PathService } from 'src/app/d3/services/path.service';
import { ComponentService } from 'src/app/services/component/component.service';
import { UserdataService } from 'src/app/services/user/userdata.service';
import { FeedbackComponent } from '../feedback/feedback.component';
import { BehaviorSubject } from 'rxjs';
import { Choice } from 'src/app/d3/models/choice';
// import { AngularFireAnalytics } from '@angular/fire/compat/analytics';
import { Link, Node, NodeData } from '../path/d3-models';
import { getAnalytics } from '@angular/fire/analytics';
import { AnalyticsService } from 'src/app/services/tracking/analytics.service';


@Component({
  selector: 'app-path-summary',
  templateUrl: './v3/path-summary.component.html',
  styleUrls: ['./v3/path-summary.component.scss'],
  providers: [NgbCollapseConfig, NgbCollapse],
  host: {
    'class':  'container cc-component-container pt-5 pt-sm-3', 
    'id': 'path-summary-backdrop'
  },
})
export class PathSummaryComponent implements OnInit {
  private screenName = CONFIG.APPLICATION.ANALYTICS.SCREENS.SUMMARY;
  private decisionCacheName = CONFIG.APPLICATION.ADDITIONAL.DECISION_CACHE_NAME;
  private appVersion = CONFIG.RELEASE.VERSION;
  socialMedia = CONFIG.APPLICATION.URL.SOCIAL_MEDIA;

  // visible: Boolean = false;
  motivatorOptions: Motivator[] = [
    new Motivator("Parent"), 
    new Motivator("Teacher"),
    new Motivator("Friends"),
    new Motivator("Others")];
  savedSessionName = CONFIG.APPLICATION.ADDITIONAL.SAVE_SESSION_NAME;
  urlPath = CONFIG.APPLICATION.URL;
  summaryIdParam = this.urlPath.PARAMS.SUMMARY_ID;
  restartPath = this.urlPath.DECISION;
  summaryPath = CONFIG.APPLICATION.PATHS.SUMMARY;
  selectedOption?: Motivator;
  traversedPaths: Node[] = [];
  decisions: Decision[] = [];
  menuOptions = [
  {
    title: 'Twitter',
    action: 'share',
    logo: '../../../../assets/images/icons/twitter-x20.png'
  }, 
  {
    title: 'Instagram',
    action: 'share',
    logo: '../../../../assets/images/icons/instagram-x20.png'
  }];
  selectedMenuOption: any = undefined;
  alertMessage?: String;
  showAlert: Boolean = false;
  analyticsConfigs = CONFIG.APPLICATION.ANALYTICS;
  errorState: Boolean = false;

  //Feedback details
  activeModalsRef : NgbModalRef[] = [];
  modalContainerSelector = CONFIG.APPLICATION.ADDITIONAL.MODAL_SELECTION_PARENT;
  // localData$  = new BehaviorSubject<User>(null);
  feedbackSubmitted: Boolean = false;
  additionalInput: Boolean = false;
  selectedCareerChoice?: Choice;
  activeId: number | null = null;
  
  @ViewChild('summaryAlert', {static: false}) summaryAlert?: NgbAlert;
  @ViewChild("collapse") collapseContent?: NgbCollapse;
  
  constructor(private route: ActivatedRoute,
      private router: Router,
      private userDataService: UserdataService,
      private pathService: PathService,
      private analyticsService : AnalyticsService,
      private modalService: NgbModal,
      private modalConfig : NgbModalConfig,
      private componentService: ComponentService,
      @Inject(DOCUMENT) private document: Document) { 
        this.componentService.setModalConfig(this.modalConfig, this.modalContainerSelector);

        let self = this;
        this.modalService.activeInstances.subscribe( (list) => {
          self.activeModalsRef.push(...list);
        });
        
        // var traversed = this.router.getCurrentNavigation().extras.state.data || false;
        // console.log("TRAVERSED: ", traversed);
        // if(traversed) {
        //   this.setData(traversed, []);
        // }
      }

  ngOnInit(): void {
    let self = this;
    this.route.params.subscribe( (params) => {
      let summaryPath = `${this.summaryPath}/${params[this.summaryIdParam]}`;

      this.pathService.getList(summaryPath).then((resp: any) => {
        let summary = new Summary(resp['enable'], resp['decisions'], resp['traversed']);
        if(!summary || !summary.traversed) {
          console.warn("No summary data found");
          return;
        } 
        self.setData(summary.traversed, summary.decisions);
        // this.localData$ = this.userDataService.localData$;
      }, (err) => {
        //Fail to load the page with information
        self.errorState = true;
        console.error(`Fail to load important resource: ${params}`, err);
      });
    });


    this.analyticsService.setCurrentScreen(this.screenName);
  }

  setData(paths: any[], decisions: Decision[]) {
    this.traversedPaths = paths;
    this.decisions = decisions;
    this.selectedCareerChoice = this.decisions[0].choices.find((c) => c.enable && c.choosen);
  }

  chooseMotivator(motivator: Motivator) {
    this.selectedOption = motivator;
    
    let analyticsParam: any = {};
    analyticsParam[this.analyticsConfigs.LOG_PARAM] = motivator.title;
    this.analyticsService.logEvent(`${this.analyticsConfigs.SCREENS.SUMMARY}-${this.analyticsConfigs.ACTIONS.MOTIVATOR}`, analyticsParam);
  }

  share(platform: string, target = '') {
    let url = (this.socialMedia as any)[platform.toUpperCase()];
    window.open(url, target);
  }

  save() {
    const sessionData = this.userDataService.localData$.getValue();
    console.log("Attempting to pull data for user: ", sessionData);
    if(!sessionData || !this.traversedPaths) {
      console.error(`Session data missing=${!!sessionData} or traversedPaths=${!!this.traversedPaths}`);
      return;
    }
    let resp : Promise<any> = this.userDataService.setTraversedPaths(sessionData.userId, this.traversedPaths);
    resp.then((success) => {
      console.log("Saving the user details complete without error: ", success);

      this.alertMessage = "User details saved";
      this.showAlert = true;
      
      setTimeout(() => { 
        this.showAlert = false; 
      }, 5000);
    }, (err) => {
      console.error("Failed to complete the save operation due to error: ", err);

      this.alertMessage = "Ooops! Save failed.";
      this.showAlert = true;

      setTimeout(() => { this.showAlert = false; }, 5000);
    })
  }

  restart() {
    window.location.href = this.restartPath
  }

  makeDecision(choice?:any) {
    if(!! choice) {
      this.selectedMenuOption = choice;
      let action = choice.action;
      let param = choice.title;

      (this as any)[action](param);
    }
  }

  //Feedback details
  openFeedback() {
    (window as any)['appzi'].openWidget(CONFIG.APPLICATION.FEEDBACK.WIDGET_ID);
  }

  closeFeedback() {
    if (this.modalService.hasOpenModals()) {
      this.modalService.dismissAll();
    }
  }

  /**
   *
   * Simple feedback sent to the 
   * @param helpful 
   */
  feedback(helpful: String) {
    (window as any)['appzi'].openWidget(CONFIG.APPLICATION.FEEDBACK.WIDGET_ID);
  }

  openFeedbackModal() {
    let ref = this.modalService.open(FeedbackComponent, this.modalConfig);
    let instance: FeedbackComponent = ref.componentInstance;

    if(! instance.canOpenFeedback(true)) {
      console.error(`Force open feedback form failed`);
      return false;
    }

    this.activeModalsRef.push(ref);
    
    //For each modals being tracked, find the appropriate one and call the respective method.
    this.activeModalsRef.forEach( (ref : NgbModalRef) => {
      const component = ref.componentInstance;
      if( component instanceof FeedbackComponent) {
        let self = this;
        component.onClose.subscribe(() => {
          self.closeFeedback();
        })
      }
    });
    return true;
  }
  closeAlert(){}

  toggle(id: number) {
    this.activeId = this.activeId === id ? null : id;
  }
}

